import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to the top of the viewport on every route change.
 *
 * One smooth scrollTo call — the browser's native smooth-scroll
 * animates from the current position (whatever the previous page
 * left us at) up to 0. Honors `html { scroll-behavior: smooth }`
 * from index.css.
 *
 * One call only — multiple racing smooth-scrolls were the original
 * bug (each new scrollTo cancels the in-progress animation, so the
 * cascade we used to have never reached 0).
 *
 * Skips when the URL has a hash — HashScrollHandler is scrolling to
 * the in-page anchor in that case; we don't want to fight it.
 *
 * Mounted once inside <BrowserRouter> in App.tsx, alongside
 * HashScrollHandler.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
